module.exports = __webpack_public_path__ + "static/media/Fail.ce3d259e.png";